import React, { Component } from 'react';
import { InputItem, Picker, List, DatePicker, TextareaItem, ImagePicker, Button, Toast, Modal } from 'antd-mobile'
import { Checkbox, Select, Spin, Icon } from 'antd';
import { req_findVisitorType, req_findSysDep, req_saveApprovalRecord, req_uploadImage, req_findTeacher, req_getTeacherByName, getConfig } from './../../api/api'
import zhCN from 'antd-mobile/lib/date-picker/locale/zh_CN';
import './index.css'
import IP from './../../config/config'
import moment from 'moment'
import cookie from 'react-cookies'
const { Option } = Select;

export default class componentName extends Component {
  state = {
    visitorTypeData: [], // 探访类型
    sysDepData: [], // 探访部门
    plate_no: '',
    approvalRecord: {
      type_id: '',
      dep_id: undefined,
      dep_name: '',
      teacher_code: '',
      work_unit: '',
      teacher_phone: '',
      start_time: '',
      end_time: '',
      description: '',
      visitor_num: 1,
    },
    visitorRecord: [{
      visitor_name: '',
      visitor_phone: '',
      visitor_image: '',
      visitor_url: []
    }],
    tabsClick: 0,
    school_campus: [], // 校区
    options: [
      { label: '南校区', value: 1 },
      { label: '北校区', value: 2 },
      { label: '医学院校区', value: 3 },
    ],
    visitMinTime: '',
    visitMaxTime: '',
    spinState: false,
    visible: false,
    configData: ''
  }

  componentDidMount = async () => {
    // 如果是分享过来的页面，就不用再查询上一次的信息了
    // await this.findSysDep();
    if (cookie.load('code') != 'null') {
      await this.findTeacher();
    }
    this._getConfig()

    await this.findVisitorType();
    this.setState({
      visitMinTime: this.zeroPadd(new Date(new Date().getTime() + 3600000)),
      visitMaxTime: this.zeroPadd(new Date(new Date().getTime() + 3 * 24 * 3600000))
    })
  }

  _getConfig = async () => {
    const res = await getConfig()
    if (res.code === 20000) {
      this.setState({
        configData: res.data
      })
    }
  }

  // 根据教师工号查询教师信息
  findTeacher = async () => {
    const res = await req_findTeacher({ teacherCode: cookie.load('code') })
    if (res.code === 20000) {
      const { approvalRecord } = this.state
      if (res.data) {
        approvalRecord.dep_id = res.data ? res.data.dep_id : ''
        approvalRecord.dep_name = res.data ? res.data.dep_name : ''
        approvalRecord.teacher_code = res.data ? res.data.teacher_code : cookie.load('code')
        approvalRecord.teacher_name = res.data ? res.data.teacher_name : ''
        this.setState({
          sysDepData: [{ dep_id: res.data.dep_id, dep_name: res.data.dep_name }]
        })
      }

      this.setState({
        approvalRecord,
      })
    }
  }

  // 获取探访类型
  findVisitorType = async () => {
    const res = await req_findVisitorType()
    if (res.code === 20000) {
      this.setState({
        visitorTypeData: res.data.map(val => {
          const item = {
            value: val.type_id,
            label: val.type_name
          }
          return item
        })
      })
    }
  }

  // 获取探访部门
  handleChangeDep = async depName => {
    this.setState({
      sysDepData: [],
      spinState: true,
    })
    const res = await req_findSysDep({ depName })
    if (res.code === 20000) {
      this.setState({
        sysDepData: res.data,
        spinState: false,
      })
    }
  }
  handleOnSelectDep = e => {
    const { approvalRecord, sysDepData } = this.state
    console.log(approvalRecord, e, sysDepData)
    approvalRecord.dep_id = e
    approvalRecord.dep_name = sysDepData.find(x => x.dep_id == e).dep_name
    this.setState({
      approvalRecord
    })
  }

  // 查询探访人
  handleOnBlurTeacher = async val => {
    const { approvalRecord } = this.state
    if (approvalRecord.dep_id) {
      const res = await req_getTeacherByName({ depId: approvalRecord.dep_id, userName: val })
      if (res.code === 20000) {
        if (res.data.length) {
          approvalRecord.teacher_code = res.data[0].teacher_code
          approvalRecord.teacher_name = res.data[0].teacher_name
        } else {
          Toast.info('暂无该人员！')
          approvalRecord.teacher_code = ''
          approvalRecord.teacher_name = ''
        }
        this.setState({
          approvalRecord
        })
      }
    } else {
      Toast.info('请先选择需要探访的部门！')
    }
  }

  // 拍照上传
  fileUpload = (files, type) => {
    if (type === "add") {
      Toast.loading("照片上传中,请稍等", 0)
      let formData = new FormData();
      formData.append("file", files[files.length - 1].file);
      req_uploadImage(formData).then(res => {
        if (res.code === 20000) {
          const { visitorRecord, tabsClick } = this.state
          visitorRecord[tabsClick].visitor_image = res.data
          visitorRecord[tabsClick].visitor_url = [{
            url: IP.host + res.data
          }]
          this.setState({
            visitorRecord
          })
          Toast.hide()
          Toast.info("上传成功", 2)
        } else {
          Toast.hide()
          Toast.fail(res.message)
        }
      })
    }
    if (type === "remove") {
      const { visitorRecord, tabsClick } = this.state
      visitorRecord[tabsClick].visitor_url = []
      visitorRecord[tabsClick].visitor_image = ''
      this.setState({
        visitorRecord
      })
    }
  }

  // 提交
  saveApprovalRecord = async () => {
    const { approvalRecord, visitorRecord, school_campus, plate_no } = this.state
    approvalRecord.teacher_phone = approvalRecord.teacher_phone.replace(/\s*/g, "")

    if (!school_campus || school_campus.length === 0 || !approvalRecord.type_id || !approvalRecord.dep_id || !approvalRecord.teacher_name || approvalRecord.teacher_name === '' || !approvalRecord.work_unit || approvalRecord.work_unit === '' || !approvalRecord.start_time || !approvalRecord.end_time || !approvalRecord.description || approvalRecord.description === '') {
      Toast.offline('请补全表单信息！')
      return false
    }

    if (approvalRecord.teacher_phone.length !== 11) {
      Toast.offline('探访人手机号不足11位请及时修改！')
      return false
    }
    // 如果code不存在，重新输入探访人
    if (approvalRecord.teacher_code === '') {
      Toast.offline('该探访人不存在，请重新输入！')
      approvalRecord.teacher_name = ''
      this.setState({
        approvalRecord
      })
      return
    }
    const newVisitorRecord = visitorRecord.map(item => {
      item.visitor_phone = item.visitor_phone.replace(/\s*/g, "")
      return item
    })
    // 访客信息验证
    for (var i = 0; i < newVisitorRecord.length; i++) {
      if (newVisitorRecord[i].visitor_name === '' || newVisitorRecord[i].visitor_phone === '' || newVisitorRecord[i].visitor_image === '') {
        Toast.offline('请补全访客' + `${i + 1}` + '信息！')
        return false
      }
      if (newVisitorRecord[i].visitor_phone.length !== 11) {
        Toast.offline(`来客${i + 1}` + '手机号不足11位请及时修改！')
        return false
      }
      if (newVisitorRecord.filter(x => newVisitorRecord[i].visitor_phone && x.visitor_phone === newVisitorRecord[i].visitor_phone).length > 1) {
        Toast.offline('多个手机号重复，请重新输入！')
        return false
      }
    }

    Toast.loading("正在提交中，请稍后...", 0)
    const data = approvalRecord
    data.type_id = approvalRecord.type_id.join(',')
    data.dep_id = approvalRecord.dep_id
    data.teacher_code = approvalRecord.teacher_code
    data.visitor_num = newVisitorRecord.length
    data.start_time = moment(approvalRecord.start_time).format('YYYY-MM-DD HH:mm')
    data.end_time = moment(approvalRecord.end_time).format('YYYY-MM-DD HH:mm')
    if (cookie.load('code') != 'null') {
      data.state = 2
    } else {
      data.state = 1
    }
    if (cookie.load('record_id')) {
      data.record_id = cookie.load('record_id')
    }
    data.school_campus = school_campus.length ? school_campus.join(',') : ''
    data.plate_no = plate_no
    const params = {
      approvalRecord: JSON.stringify(data),
      visitorRecord: JSON.stringify(newVisitorRecord)
    }

    const res = await req_saveApprovalRecord(params)
    if (res.code === 20000) {
      Toast.hide()
      Toast.success(res.message, 5)
      this.setState({
        plate_no: '',
        approvalRecord: {
          type_id: '',
          dep_id: undefined,
          dep_name: '',
          teacher_code: '',
          work_unit: '',
          teacher_phone: '',
          start_time: undefined,
          end_time: undefined,
          description: '',
          visitor_num: 1,
        },
        visitorRecord: [{
          visitor_name: '',
          visitor_phone: '',
          visitor_image: '',
          visitor_url: []
        }],
        tabsClick: 0,
        school_campus: [],
      })
      // 如果是分享过来的页面，就不用再查询上一次的信息了
      if (cookie.load('code') != 'null') {
        await this.findTeacher();
      }
    }
  }

  zeroPadd = (date) => {
    var hours = date.getHours();				// 获取时
    var minutes = date.getMinutes();		// 获取分
    var year = date.getFullYear();				// 获取年
    var month = date.getMonth();		// 获取月
    var strDate = date.getDate();				// 获取日

    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    if (hours >= 0 && hours <= 9) {
      hours = "0" + hours;
    }
    if (minutes >= 0 && minutes <= 9) {
      minutes = "0" + minutes;
    }

    var date = new Date(year, month, strDate, hours, minutes, 0)
    return date;
  }

  render() {
    const { visitorTypeData, sysDepData, approvalRecord, school_campus, visitorRecord, tabsClick, options, visitMinTime, visitMaxTime, visible, configData, plate_no } = this.state
    return (
      <div className="register">
        <div className="register-top">
          <div className="item-select" style={{ marginTop: '20px', padding: '7px 0px', display: 'flex', justifyContent: 'space-between' }}>
            <div className='item-select-Checkbox-title'><span style={{ color: 'red' }}>* </span>访问校区</div>
            <div style={{ width: '111px' }}>
              <Checkbox.Group options={options} value={school_campus} onChange={(value) => {
                this.setState({
                  school_campus: value
                })
              }} />
            </div>

          </div>
          <div className="item-select" style={{ marginTop: '20px' }}>
            <Picker
              extra="请选择探访类型"
              data={visitorTypeData}
              cols={1}
              value={approvalRecord.type_id}
              onChange={(val) => {
                approvalRecord.type_id = val
                approvalRecord.type_name = visitorTypeData.find(x => x.value == val).label
                this.setState({
                  approvalRecord
                })
              }}
            >
              <List.Item arrow="horizontal"><span style={{ color: 'red' }}>* </span>探访类型</List.Item>
            </Picker>
          </div>
          <div className="item_select">
            <div className='item_select_title'><span style={{ color: 'red' }}>* </span>探访部门</div>
            <Select disabled={cookie.load('code') != 'null' ? true : false} placeholder="请选择探访部门" showSearch onSearch={e => this.handleChangeDep(e)} showArrow={false} filterOption={false} optionFilterProp="label" value={approvalRecord.dep_id} defaultActiveFirstOption={false} notFoundContent={this.state.spinState ? <Spin size="small" /> : null} onSelect={e => this.handleOnSelectDep(e)}>
              {
                (sysDepData || []).map(item => {
                  return <Option key={item.dep_id} value={item.dep_id}>{item.dep_name}</Option>
                })
              }
            </Select>
          </div>
          <div className="item-input" style={{ marginTop: '0px' }}>
            <InputItem
              placeholder="请输入探访人"
              value={approvalRecord.teacher_name}
              disabled={cookie.load('code') != 'null' || !approvalRecord.dep_id ? true : false}
              onChange={(val) => {
                approvalRecord.teacher_name = val
                this.setState({
                  approvalRecord
                })
              }}
              onBlur={val => this.handleOnBlurTeacher(val)}
            ><span style={{ color: 'red' }}>* </span>探访人</InputItem>
          </div>
          <div className="item-input" style={{ marginTop: '0px' }}>
            <InputItem
              type='number'
              placeholder="请输入探访人手机号"
              error={!approvalRecord.teacher_phone || approvalRecord.teacher_phone.length === 11 ? false : true}
              value={approvalRecord.teacher_phone}
              onChange={(val) => {
                approvalRecord.teacher_phone = val
                this.setState({
                  approvalRecord
                })
              }}
            ><span style={{ color: 'red' }}>* </span>手机号</InputItem>
          </div>
        </div>

        <div className="register-main">
          <div className="item-input" style={{ marginTop: '0px' }}>
            <InputItem
              placeholder="请输入来访单位"
              value={approvalRecord.work_unit}
              onChange={(val) => {
                approvalRecord.work_unit = val
                this.setState({
                  approvalRecord
                })
              }}
            ><span style={{ color: 'red' }}>* </span>来访单位</InputItem>
          </div>
          <div className="item-date">
            <DatePicker locale={zhCN} extra="请选择" value={approvalRecord.start_time} onChange={(val) => {
              approvalRecord.start_time = val
              approvalRecord.end_time = undefined
              this.setState({
                approvalRecord,
                visitMinTime: this.zeroPadd(new Date(new Date(val).getTime() + 3600000)),
                visitMaxTime: this.zeroPadd(new Date(new Date(val).getTime() + 3 * 24 * 3600000))
              })
            }}>
              <List.Item arrow="horizontal"><span style={{ color: 'red' }}>* </span>探访开始时间</List.Item>
            </DatePicker>
          </div>
          <div className="item-date" style={{ marginBottom: '0px' }}>
            <DatePicker locale={zhCN} extra="请选择" disabled={approvalRecord.start_time ? false : true} value={approvalRecord.end_time} minDate={visitMinTime} maxDate={visitMaxTime} onChange={(val) => {
              approvalRecord.end_time = val
              this.setState({
                approvalRecord
              })
            }}>
              <List.Item arrow="horizontal"><span style={{ color: 'red' }}>* </span>探访结束时间</List.Item>
            </DatePicker>
          </div>
          {/* <div className="item-input">
            <InputItem
              type='number'
              placeholder="请输入来客数量"
              value={approvalRecord.visitor_num}
              onChange={(val)=>{
                if(val==='' || val === '0'){
                  val=1
                }
                // 计算数量是增加还是减少了
                if(approvalRecord.visitor_num<val){
                  const maxNnum = val-approvalRecord.visitor_num
                  const first = {
                      visitor_name: '',
                      visitor_phone: '',
                      visitor_image: ''
                    }
                  for(var i=0;i<maxNnum;i++){
                    visitorRecord.push(first)
                  }
                }else{
                  const minNnum = approvalRecord.visitor_num-val
                  for(var i=0;i<minNnum;i++){
                    visitorRecord.pop()
                  }
                }
                approvalRecord.visitor_num=val
                this.setState({
                  approvalRecord,
                  visitorRecord
                })
              }}
            >来客数量</InputItem>
          </div> */}

          {configData && configData.plate_no_state === 1 ? (<div className="item-input" >
            <InputItem
              placeholder="请输入车牌号"
              value={plate_no}
              onChange={(val) => {
                this.setState({
                  plate_no: val
                })
              }}
            >&nbsp;&nbsp;车牌号  {configData && configData.is_charge === 0 ? (<Icon style={{ fontSize: 16 }} type='question-circle' onClick={() => {
              Toast.info('提示：车辆进出需收费，具体收费请咨询保卫处。');
            }} />) : ""}
            </InputItem>
          </div>) : ''}

          <div className="item-text">
            <div className="item-text-title"><span style={{ color: 'red' }}>* </span>探访事由</div>
            <TextareaItem
              placeholder="请输入探访事由"
              rows={5}
              value={approvalRecord.description}
              onChange={(val) => {
                approvalRecord.description = val
                this.setState({
                  approvalRecord
                })
              }}
            />
          </div>

        </div>
        <div className="register-foot">
          <div className="register-tabs">
            <div className="register-tabs-scroll">
              <div className="register-tabs-width">
                {
                  visitorRecord.map((val, key) => {
                    return (<div className={tabsClick === key ? 'register-tabs-click' : ''} key={key} onClick={() => {
                      this.setState({
                        tabsClick: key
                      })
                    }}>来客{key + 1}</div>)
                  })
                }
              </div>
            </div>
          </div>

          <div className="item-input">
            <InputItem
              placeholder="请输入来客姓名"
              value={visitorRecord[tabsClick].visitor_name}
              onChange={(val) => {
                visitorRecord[tabsClick].visitor_name = val
                this.setState({
                  visitorRecord
                })
              }}
            ><span style={{ color: 'red' }}>* </span>来客姓名</InputItem>
          </div>
          <div className="item-input">
            <InputItem
              type='number'
              placeholder="请输入手机号"
              error={!visitorRecord[tabsClick].visitor_phone || visitorRecord[tabsClick].visitor_phone.length === 11 ? false : true}
              value={visitorRecord[tabsClick].visitor_phone}
              onChange={(val) => {
                visitorRecord[tabsClick].visitor_phone = val
                this.setState({
                  visitorRecord
                })
              }}
            ><span style={{ color: 'red' }}>* </span>手机号</InputItem>
          </div>
          <div className="item-upload">
            <div className="item-upload-title" style={{ marginTop: '6px' }}>
              <div><span style={{ color: 'red' }}>* </span>拍照上传</div>
              {/* <div onClick={() => {
                this.setState({
                  visible: true
                })
              }}>查看 <span>照片上传示例</span></div> */}
            </div>
            <div style={{ display: 'flex', width: '100%' }}>
              <div style={{ width: '100px', flex: '1 1' }}>
                <ImagePicker
                  selectable={visitorRecord[tabsClick].visitor_url.length != 1}
                  multiple={false}
                  capture="camera"
                  className="register_image"
                  length={1}
                  files={visitorRecord[tabsClick].visitor_url}
                  onChange={(files, type) => {
                    this.fileUpload(files, type);
                  }}
                />
              </div>
              <div>
                <img src={require('./../../images/example.jpg')} style={{ width: '100%' }} alt='' />
              </div>
            </div>
          </div>
          <div className="register-count">
            <Button onClick={() => {
              const item = {
                visitor_name: '',
                visitor_phone: '',
                visitor_image: '',
                visitor_url: []
              }
              visitorRecord.push(item)
              this.setState({
                visitorRecord,
                tabsClick: visitorRecord.length - 1,
              })
            }}>+</Button>
            <Button onClick={() => {
              if (visitorRecord.length > 1) {
                visitorRecord.pop()
              }
              this.setState({
                visitorRecord,
                tabsClick: 0
              })
            }}>-</Button>
          </div>
        </div>
        <div className="register-but">
          <div onClick={() => {
            this.saveApprovalRecord()
          }}>提交</div>
        </div>
        <Modal
          popup
          visible={visible}
          title="照片上传示例"
          onClose={() => {
            this.setState({
              visible: false
            })
          }}
          animationType="slide-up"
          className="modal_popup"
        >
          <img src={require('./../../images/example.jpg')} style={{ width: '100%' }} alt='' />
        </Modal>
      </div >
    );
  }
}
